import { Button, Tag } from 'antd'
import { ColumnType } from 'antd/es/table'
import dayjs from 'dayjs'
import { useNavigate, useParams } from 'react-router-dom'

import { GetTreatmentPlanRecipeListResponseItem } from 'src/api/requests'
import { getRecipeStatus } from 'src/features/persons/utils/recipes'
import { dayMonthYearBackSlash } from 'src/libs'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

export const useRecipesColumns = (showPerson?: boolean) => {
  const { t } = useLocales()
  const navigate = useNavigate()
  const { id: personId } = useParams()

  const columns: ColumnType<GetTreatmentPlanRecipeListResponseItem>[] = [
    ...(showPerson
      ? [
          {
            key: 'last name',
            dataIndex: ['person', 'lastName'],
            title: t('form.last_name')
          },
          {
            key: 'first name',
            dataIndex: ['person', 'firstName'],
            title: t('form.first_name')
          }
        ]
      : [
          {
            key: 'id',
            title: t('consultations.recipe_number'),
            render: (_: unknown, __: unknown, index: number) => `${index + 1}`
          }
        ]),
    {
      key: 'dateIssued',
      title: t('consultations.recipe_date'),
      render: ({ dateIssued }) =>
        dateIssued ? dayjs(dateIssued).utc().format(dayMonthYearBackSlash) : '-'
    },
    {
      key: 'dispensingDate',
      title: t('stock_administration.release_date'),
      render: ({ dispensingDate }) =>
        dispensingDate
          ? dayjs(dispensingDate).utc().format(dayMonthYearBackSlash)
          : '-'
    },
    {
      key: 'status',
      title: t('form.status'),
      render: ({ status }) => {
        return (
          <Tag color={getRecipeStatus(t, status).color} key={status}>
            {getRecipeStatus(t, status).text}
          </Tag>
        )
      }
    },
    {
      key: 'actions',
      align: 'end',
      render: ({ id, treatmentPlanId, person }) => (
        <Button
          type="link"
          onClick={() =>
            navigate(
              paths.patients.recipes.details(
                String(personId ?? person?.id),
                treatmentPlanId,
                id
              )
            )
          }
        >
          {t('common.see_details')}
        </Button>
      )
    }
  ]

  return { columns }
}
